import { UserOverview } from "components/Panel/Admin/UserOverview";

export const AdminUserOverView = () => {
    return <UserOverview />;
};
